import {
	ADD_LEGEND,
	ENTRY_FILTER,
	READ_NEWS,
	RECEIVE_ALL_SOURCES,
	RECEIVE_DATA_TYPE_STATISTICS,
	RECEIVE_LEGENDS,
	RECEIVE_NEWS,
	RECEIVE_THEMES,
	REMOVE_LEGEND,
	RESET_ADMINISTRATION_STORE,
	RESET_ENTRY_FILTER,
	RESET_SELECTED_FILTERS,
	RESET_SELECTED_THEMES,
	SELECTED_FILTERS,
	SELECTED_THEMES
} from '../constants/AdministrationConstants'
import MasterThemeDto from '../dto/MasterThemeDto'
import DtoSource from '../dto/DtoSource'
import LegendDto from '../dto/LegendDto'
import NewsDto from '../dto/NewsDto'
import { differenceBy, filter, uniq } from 'lodash'
import DtoDataTypeStatistics from '../dto/DtoDataTypeStatistics'

export const store = {
	themes: [],
	selectedThemes: [],
	selectedFilters: [],
	filterEntry: '',
	sources: [],
	dataTypeStatistics: [],
	legends: [],
	news: []
}

export function AdministrationReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_THEMES:
			return Object.assign({}, state, {
				themes: action.themes.map(t => new MasterThemeDto(t))
			})
		case SELECTED_THEMES:
			return Object.assign({}, state, {
				selectedThemes: action.selectedThemes
			})
		case SELECTED_FILTERS:
			return Object.assign({}, state, {
				selectedFilters: action.selectedFilters
			})
		case ENTRY_FILTER:
			return Object.assign({}, state, {
				filterEntry: action.filterEntry
			})
		case RESET_SELECTED_THEMES:
			return Object.assign({}, state, {
				selectedThemes: []
			})
		case RESET_SELECTED_FILTERS:
			return Object.assign({}, state, {
				selectedFilters: []
			})
		case RESET_ENTRY_FILTER:
			return Object.assign({}, state, {
				filterEntry: ''
			})
		case RECEIVE_ALL_SOURCES:
			return Object.assign({}, state, {
				sources: action.sources.map(t => new DtoSource(t))
			})
		case RECEIVE_DATA_TYPE_STATISTICS:
			return Object.assign({}, state, {
				dataTypeStatistics: action.dataTypeStatistics.map(o => new DtoDataTypeStatistics(o))
			})
		case RECEIVE_LEGENDS:
			return Object.assign({}, state, {
				legends: action.legends.map(o => new LegendDto(o))
			})
		case RECEIVE_NEWS:
			const difference = differenceBy(action.news, state.news, 'id').map(o => new NewsDto(o))
			return Object.assign({}, state, {
				news: [].concat(difference, state.news).sort((a, b) => b.date - a.date)
			})
		case READ_NEWS:
			return Object.assign({}, state, {
				news: action.news.map(o => new NewsDto(Object.assign({}, o, { status: 0 })))
			})
		case ADD_LEGEND:
			if (action.legend.content) {
				const boxes = state.legends.slice()
				const nbBoxes = boxes.length
				const left = nbBoxes ? boxes[nbBoxes - 1].left + 5 : 5
				const top = nbBoxes ? boxes[nbBoxes - 1].top + 5 : 300
				const legend = Object.assign({}, action.legend, {
					left: left,
					top: top
				})
				boxes.push(legend)
				return Object.assign({}, state, {
					legends: uniq(boxes)
				})
			}
			return Object.assign({}, state, {
				legends: state.legends
			})
		case REMOVE_LEGEND:
			const boxes = state.legends.slice()
			const result = filter(boxes, o => o.id !== action.legendId)
			return Object.assign({}, state, {
				legends: result
			})
		case RESET_ADMINISTRATION_STORE:
			return Object.assign({}, state, store)
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/administration/reducers/AdministrationReducer.js